import { useMutation } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { resendPendingInvites } from 'Services/JOONAdmin/joonAdminEmployersService'

export const useResendPendingInvitesQuery = () =>
  useMutation([QueryNames.ResendPendingInvites], resendPendingInvites, {
    onSuccess: (response) => {
      const resentCount = response.data?.resentCount

      if (!response.success || resentCount === undefined) {
        toast.error(`${AppNotification.ResendPendingInvitesFailure} ${response.message}`)
      } else if (resentCount === 0) {
        toast.info(AppNotification.ResendPendingInvitesNone)
      } else {
        toast.success(`Resent ${resentCount} ${resentCount === 1 ? 'invite' : 'invites'}.`)
      }
    },
    onError: (error: { message: string }) => {
      toast.error(`${AppNotification.ResendPendingInvitesFailure} ${error.message}`)
    }
  })
